<template>
	<form class='form' @submit.stop.prevent="submit">
		<h4>Мониторинг актов ЛПО</h4>
		<div class="row">
			<div class="col-md-1 col"><span class="bold">№ акта ЛПО *</span></div>
			<div class="col-md-2 col"><span class="bold">Организация *</span></div>
			<div class="col-md-6 col">Ссылка на акт</div>
		</div>
		<div class="row">
			<div class="col-md-1 col"><input type="text" v-model='f_2' class='form-control my-control' :class='fields_correct.f_2'></input></div>
			<div class="col-md-2 col"><organization :field_class='fields_correct.f_11'></organization></div>
			<div class="col-md-6 col"><input type="text" v-model='f_4' class='form-control my-control'></input></div>
		</div>
		<div class="row">
			<div class="col-md-3 col">Федеральный округ</div>
			<div class="col-md-3 col"><span class="bold">Субъект РФ *</span></div>
			<div class="col-md-3 col"><span class="bold">Лесничество *</span></div>
		</div>
		<div class="row">
			<div class="col-md-3 col"><fo type='add'></fo></div>	<!-- FO -->
			<div class="col-md-3 col">
				<region type='add' :field_class='fields_correct.f_12' :region_id="f_12"></region>
			</div>
			<div class="col-md-3 col">
				<forestry type='add' :field_class='fields_correct.f_9' :forestry_id="f_9"></forestry>
			</div>
		</div>
		<hr>

		<div class="row">
			<div class="col-sm-7" style="margin-bottom: 5px;">
				 <input id='btnAddLine' @click='addLine' value='Добавить' type='button' disabled='true' :class='lines_correct' /> <input id='btnCopyLine' @click='copyLine' value='Дублировать отмеченное' type='button' disabled='true' /> <input id='btnDeleteLine' @click='deleteLine' value='Удалить отмеченное' type='button' disabled='true' />
			</div>
		</div>
		<div class="row">
			<div class="col-sm-12">
				<table class='place_table'>
					<thead>
						<tr>
							<th class="form_td_chkbox"><input id="chkBoxSelAll" @click='selectAll' type='checkbox' style='margin: 5px'/></th>
							<th class="form_td">Участковое лесничество *</th>
							<th class="form_td">Подлес-во</th>
							<th class="form_td">Квартал *</th>
							<th class="form_td">Выдел *</th>
							<th class="form_td">S выдела *</th>
							<th class="form_td">Лп. выдел</th>
							<th class="form_td">S лп. выдела</th>
							<th class="form_td">Состав</th>
							<th class="form_td">Возраст</th>
							<th class="form_td">Полнота</th>
							<th class="form_td">Запас</th>
							<location-table-field field_name="f_131" @set="setSKSAllLocations" title="СКС насаждения">
								СКС насаждения
							</location-table-field>
							<th class="form_td">МЗЛ *</th>
							<th class="form_td">S МЗЛ (для РАД шт.)</th>
							<th class="form_td">V(м<sup>3</sup>)</th>
							<!-- -->
							<th class="form_td">Целевое назначение лесов</th>
							<th class="form_td">Категория защитных лесов</th>
							<th class="form_td">ОЗУ</th>
							<!-- -->
							<th class="form_td">Порода</th>
							<th class="form_td">Причина ослабления</th>
							<th class="form_td">Комментарии</th>
						</tr>
					</thead>
					<tbody>
						<tr v-for='(line, index) in lines'>
							<td class="form_td_chkbox">
								<input type="checkbox" class="checkbox control-access-first" :data-index='index'/>
							</td>
							<td class='form_td' :class='line.correct_f_20'>
								<localforestry :line_count='index' type='add' :forestry_id="f_9" :lf_id='line.f_20'></localforestry>
							</td>
							<td class='form_td' style='border-right: none'>
								<subforestry :line_count='index' type='add' :lf_id='line.f_20' :sf_id='line.f_27'></subforestry>
							</td>
							<td class='form_td' :class='line.correct_f_17'>
								<input type="text" @keyup='tdChange' class='form-control table-control my-control' v-model='line.f_17' data-field='f_17' :line_count='index'></input>
							</td>
							<td class='form_td' :class='line.correct_f_24'>
								<input type="text" @keyup='tdChange' class='form-control table-control my-control' v-model='line.f_24' data-field='f_24' :line_count='index'></input>
							</td>
							<td class='form_td' :class='line.correct_f_21'>
								<input type="text" @keyup='tdChange' class='form-control table-control my-control' v-model='line.f_21' data-field='f_21' :line_count='index'></input>
							</td>
							<td class='form_td'>
								<input type="text" class='form-control table-control my-control' v-model='line.f_25'></input>
							</td>
							<td class='form_td' style='border-right: none' :class='line.correct_f_23'>
								<input type="text" @keyup='addSLP' class='form-control table-control my-control' v-model='line.f_23' data-field='f_23' :data-line='index'></input>
							</td>
							<!-- -->
							<td class='form_td' style='border-right: none' :class='line.correct_f_111'>
								<input type="text" class='table-control form-control my-control' data-field='f_111' :data-line='index' v-model='line.f_111'></input>
							</td>
							<td class='form_td' style='border-right: none' :class='line.correct_f_112'>
								<input type="text" class='table-control form-control my-control' data-field='f_112' :data-line='index' v-model='line.f_112'></input>
							</td>
							<td class='form_td' style='border-right: none' :class='line.correct_f_113'>
								<input type="text" class='table-control form-control my-control' data-field='f_113' :data-line='index' v-model='line.f_113'></input>
							</td>
							<td class='form_td' style='border-right: none' :class='line.correct_f_114'>
								<input type="text" class='table-control form-control my-control' data-field='f_114' :data-line='index' v-model='line.f_114'></input>
							</td>
							<td class='form_td' style='border-right: none' :class='line.f_131 ? "" : "field-error"'>
								<input type="text" class='table-control form-control my-control' data-field='f_131' :data-line='index' v-model='line.f_131'></input>
							</td>
							<!-- -->
							<td class='form_td'>
								<action-type :line_count='index' :id="line.f_16"></action-type>
							</td>
							<td class='form_td' style="position: relative;" :class='line.correct_f_22'>
								<input type="text" @keyup='addSAT' class='form-control table-control my-control' v-model='line.f_22' data-field='f_22' :data-line='index' @blur='(e) => {tryBlurMzl(e, line.f_22, line.f_16 == mzlRAD.id)}'></input>
								<tooltip-warn :value='line.f_22' :type-is-rad='line.f_16 == mzlRAD.id' :key='index' :id='index'></tooltip-warn>
							</td>
							<!-- -->
							<td class='form_td'>
								<input type="text" class='table-control form-control my-control' data-field='f_116' :data-line='index' v-model='line.f_116'></input>
							</td>
							<td class='form_td'>
								<forest-purpose :line_count='index' type='add' :id="line.f_104"></forest-purpose>
							</td>
							<td class='form_td'>
								<protective-cat :line_count='index' :id="line.f_105" type='add'></protective-cat>
							</td>
							<td class='form_td'>
								<protective-cat-ext :line_count='index' type='add'></protective-cat-ext>
							</td>
							<!-- -->
							<td class='form_td'>
								<species :line_count='index' :sp_id="line.f_26"></species>
							</td>
							<td class='form_td'>
								<damage-reason :line_count='index' :id="line.f_19"></damage-reason>
							</td>
							<td class='form_td'>
								<input type="text" class='form-control table-control my-control' v-model='line.f_18'></input>
							</td>
						</tr>
					</tbody>
				</table>
			</div>
		</div>
		<!-- <div class="row">
			<div class="col-md-5"></div>
			<div class="col-md-1"><span style='vertical-align: sub'>Итого</span></div>
			<div class="col-md-1"><input type="text" v-model='summ_s_lp' class='form-control my-control' disabled></input></div>
			<div class="col-md-1"></div>
			<div class="col-md-1"><input type="text" v-model='summ_s_action_type' class='form-control my-control' disabled></input></div>
		</div> -->
		<div class="row" style="margin-top: 20px; margin-bottom: 10px;">
			<div class="col-md-1">
				<div class='left_input_wrapper'>
					<span class="bold">S ЛПО *</span>
					<input type="text" style='float:right;' class='short my-control form-control' v-model='f_13' :class='fields_correct.f_13'></input>
				</div>

				<!-- <div class='left_input_wrapper'>
					<span class="bold">V(м<sup>3</sup>)</span>
					<input type="text" style='float:right;' class='short form-control my-control' v-model='f_115' :class='fields_correct.f_115'></input>
				</div> -->
			</div>


			<!--
			<div class="col-md-1">
				УАД/шт.
				<input type="text" class='short my-control form-control' v-model='f_14'></input>
			</div>
			-->
			<div class="col-md-11">
				<table class='table-mzl'>
					<thead>
						<tr>
							<th>
								S лп. выдела
							</th>
							<th>
								{{ mzlRAD.name }}
							</th>
							<th>
								V(м<sup>3</sup>)
							</th>
							<th v-for='item in mzlNoRAD'>
								{{ item.name }}
							</th>
						</tr>
					</thead>
					<tbody>
						<tr>
							<td rowspan='2'>{{ summ_s_lp }}</td>
							<td rowspan='2'>{{ mzlRAD.value }}</td>
							<td rowspan='2'>{{ value_summ }}</td>
							<td v-for='item in mzlNoRAD'>
								{{ item.value }}
							</td>
						</tr>
						<tr>
							<td :colspan='mzl.length'>{{ floatConvert(summ_s_action_type - mzlRAD.value) }}</td>
						</tr>
					</tbody>
				</table>
			</div>
		</div>

		<div class="row">
			<!-- <div class="col-md-2"></div> -->
			<div class="col-md-1 col-md-offset-2">
				<label>Контроль 3 дня</label>
			</div>
			<div class="col-md-1" style="margin-left: 6.33%">
				<label>Даты</label>
			</div>
		</div>
		<div class="row">
			<div class="col-sm-8">
				<table class='dateTable'>
					<thead>
						<tr>
							<th>проведения ЛПО *</th>
							<th>утверждения *</th>
							<th>размещения на сайте *</th>
							<th>контроль 20 дней</th>
							<th>осталось дней</th>
						</tr>
					</thead>
					<tbody>
						<tr>
							<td :class='fields_correct.f_1'>
								<datepicker
									v-model='f_1'
									format='dd.MM.yyyy'
									class='table-control'
								></datepicker>
							</td>
							<td :class='fields_correct.f_5'>
								<datepicker
									id='datepicker_f_5'
									v-model='f_5'
									format='dd.MM.yyyy'
									class='table-control'
									@input='adoptionChange'
								></datepicker>
							</td>
							<td :class='fields_correct.f_3'>
								<datepicker
									id='datepicker_f_3'
									@input='placeChange'
									v-model='f_3'
									format='dd.MM.yyyy'
									class='table-control'
								></datepicker>
							</td>
							<td>
								<input type="text" class='table-control my-control form-control' v-model='controlTwenty' disabled></input>
							</td>
							<td>
								<input type="text" class='table-control my-control form-control' v-model='daysLeft' disabled></input>
							</td>
						</tr>
					</tbody>
				</table>
			</div>
			<div class="col-md-4">
				<div class="rent-title">Аренда</div>
				<select v-model='f_126' class='form-control my-control medium' :class='fields_correct.f_126'>
					<option :value="null"></option>
					<option :value="true">Да</option>
					<option :value="false">Нет</option>
				</select>
			</div>
		</div>
		<div class="row" style='margin: 5px;'></div>
		<div class="row">
			<div class="col-sm-8">
				<table class="dateTable">
					<thead>
						<tr>
							<th>Основание проведения ЛПО</th>
							<th>Метод проведения ЛПО</th>
							<th>Способ проведения ЛПО</th>
						</tr>
					</thead>
					<tbody>
						<td><lpo-reason></lpo-reason></td>
						<td><lpo-method :id="f_89"></lpo-method></td>
						<td><lpo-mode :method='f_89' :id="f_90"></lpo-mode></td>
					</tbody>
				</table>
			</div>
		</div>
		<div class="row" style='margin: 5px;'></div>
		<div class="row">
			<div class="col-sm-8">
				<table class='dateTable'>
					<thead>
						<tr>
							<th>Дата снятия с сайта</th>
							<th>Причина снятия с сайта Акта ЛПО</th>
							<th>Ответственный за заключение на акты ЛПО</th>
						</tr>
					</thead>
					<tbody>
						<tr>
							<td>
								<datepicker
									v-model='f_7'
									format='dd.MM.yyyy'
									class='table-control'
								></datepicker>
							</td>
							<td>
								<deletion-reason></deletion-reason>
							</td>
							<td>
								<conclusion-user :conc_id='f_6'></conclusion-user>
							</td>
						</tr>
					</tbody>
				</table>
			</div>
			<div class="col-md-4">
				<select v-model='f_10' class='form-control my-control medium'>
					<option value="1">Черновик</option>
					<option value="0">Чистовик</option>
				</select>
			</div>
		</div>
		<div class="row" style='margin: 5px;'></div>
		<div class="row">
			<div class="col-sm-8">
				<table class='dateTable no-bottom-border'>
					<thead>
						<tr>
							<th colspan="4">Исполнитель работ по ЛПО</th>
						</tr>
					</thead>
				</table>
				<table class='dateTable'>
					<tbody>
						<tr>
							<td style="width: 15%;" class="no-right-border">ФИО</td>
							<td :class='fields_correct.f_127'>
								<input 
									v-model="f_127" 
									type="text" 
									class='table-control my-control form-control'
								>
							</td>
							<td style="width: 20%;" class="no-right-border">
								<select 
									v-model="f_129"
									@change="change_f_129" 
									class="form-control my-control table-control">
									<option v-for="type in organization_types" :value="type.id" :key="type.id">
										{{ type.name }}
									</option>
								</select>
							</td>
							<td :class='f_129 == 2 ? fields_correct.f_128 : fields_correct.f_130'>
								<select v-if="f_129 == 1" v-model="f_130" class="form-control my-control table-control">
									<option v-for="item in lpo_filials" :value="item.id" :key="item.id">
										{{ item.name }}
									</option>
								</select>
								<input 
									v-if="f_129 == 2"
									v-model="f_128" 
									type="text" 
									class='table-control my-control form-control'
								>
							</td>
						</tr>
					</tbody>
				</table>
			</div>
		</div>
		<hr>

		<div class='btnPanel'>
			<!-- <b-button class='clearBtn' @click.prevent='clearForm' variant='secondary'>Очистить</b-button> -->
			<input type='button' class='btn btn-secondary' @click.prevent="close" value='Отмена'></input>
			<button class='btn btn-primary' @click.prevent='submit' :disabled="submit_disabled">
				<i class='fa fa-spinner fa-spin' v-if='submit_disabled'></i>
				{{ submit_disabled ? 'Сохранение' : 'Сохранить' }}
			</button>
		</div>
	</form>
</template>

<script>
	import auth from '../../auth'
	import router from '../../router'

	import fo from './fetch_data/fo'
	import region from './fetch_data/region'
	import forestry from './fetch_data/forestry'
	import localforestry from './fetch_data/localforestry'
	import subforestry from './fetch_data/subforestry'
	import species from './fetch_data/species'
	import conclusionUser from './fetch_data/conclusionUser'
	import organization from './fetch_data/organization'
	import actionType from './fetch_data/actionType'
	import deletionReason from './fetch_data/deletionReason'
	import damageReason from './fetch_data/damages'
	
	import lpoReason from './fetch_data/lpoReason'
	import lpoMethod from './fetch_data/lpoMethod'
	import lpoMode from './fetch_data/lpoMode'

	import forestPurpose from './fetch_data/forestPurpose'
	import protectiveCat from './fetch_data/protectiveCat'
	import protectiveCatExt from './fetch_data/protectiveCatExt'

	import tooltipWarn from './fetch_data/tooltipWarn'

	import locationTableField from './fetch_data/locationTableField'

	import { datepicker } from 'vue-strap'

	//import datePick from './../datePicker'
	import moment from 'moment'
	// import jQuery from "jquery";  
	// import datePicker from 'vue-bootstrap-datetimepicker';
	// import 'eonasdan-bootstrap-datetimepicker/build/css/bootstrap-datetimepicker.css';

	import {DB} from './../../constants'
	const INSERT_JSON = 'insert_json.php'
	const ACTION_TYPE = 'get_action_type.php'
	const CAN_EDIT = 'can_edit_unit.php'
	const LPO_FILIALS = 'get_lpo_filials.php'
	const ORGANIZATION_LPO = 'get_organization_lpo.php'
	const FIND_ACT = 'find_act.php'
	const UNIT_ID = 1
	const TIMEOUT = 10 * 60 * 1000 // 10 минут

	import { EventBus } from '../../lib/EventBus'
	import '../../lib/css/fontawesome-all.min.css'

	export default {
		name: 'addForm',
		data: function () {
			return {
				line_count: 0,
				lines: [],
				mzl: [],
				mzlNoRAD: [],
				mzlRAD: [],
				f_1: '',
				f_2: '',
				f_3: '',
				f_4: '',
				f_5: '',
				f_6: auth.user.id,
				f_7: '',
				f_8: 0,
				f_9: 0,
				f_10: 1,
				f_11: 0,
				f_12: 0,
				f_13: '',
				f_14: '',
				f_15: auth.user.id,
				f_89: null,
				f_90: null,

				f_126: null,
				f_127: null,
				f_128: null,
				f_129: 2,
				f_130: null,

				f_115: '',
			/*	f_16: [],
				f_17: [],
				f_18: [],
				f_19: [],
				f_20: [],
				f_21: [],
				f_22: [],
				f_23: [],
				f_24: [],
				f_25: [],
				f_26: [],
				f_27: [],*/

				controlTwenty: '',
				daysLeft: '',
				summ_s_lp: 0,
				summ_s_action_type: 0,
				value_summ: 0,

				fields_correct: {
					f_1: 'field-error',
					f_2: 'field-error',
					f_3: 'field-error',
					f_5: 'field-error',
					f_9: 'field-error',
					f_11: 'field-error',
					f_12: 'field-error',
					f_13: 'field-error',
					f_126: 'field-error',
					f_127: 'field-error',
					f_128: 'field-error',
					f_130: 'field-error'
				},

				organization_types: [],
				lpo_filials: [],

				lines_correct: 'field-error',
				submit_disabled: false,
			}
		},
		components: {
			region,
			forestry,
			localforestry,
			subforestry,
			fo,
			species,
			conclusionUser,
			organization,
			actionType,
			deletionReason,
			damageReason,
			datepicker,
			lpoReason,
			lpoMethod,
			lpoMode,
			forestPurpose,
			protectiveCat,
			protectiveCatExt,
			tooltipWarn,
			locationTableField
		},
		methods: {
			tryBlurMzl (e, val, type) {
				//if(type && !Number.isInteger(Number(val)))
				//	setTimeout(() => e.target.focus(), 10)
			},
			floatConvert (number) {
			    return +(parseFloat(number).toPrecision(12))
			},
			filterInput (e) {
				e.target.value = e.target.value.replace(/[,-]/g, ".").replace(/[^\.\d]/g, "")
			},
			addSLP (e) {
				if(e) {
					e.target.value = e.target.value.replace(/[,-]/g, ".")
					const f = e.target.getAttribute('data-field')
					const l = e.target.getAttribute('data-line')

					this.lines[l][f] = e.target.value
				}

				let s = 0
				for (let i = 0; i < this.lines.length; i++) {
					s += +this.lines[i].f_23
				}

				this.summ_s_lp = this.floatConvert(s)
			},
			addSAT (e) {
				if(e) {
					e.target.value = e.target.value.replace(/[,-]/g, ".")
					const f = e.target.getAttribute('data-field')
					const l = e.target.getAttribute('data-line')

					this.lines[l][f] = e.target.value
				}

				let s = 0

				for (let i = 0; i < this.mzl.length; i++) {
					this.mzl[i].value = 0
				}

				for (let j = 0; j < this.lines.length; j++) {
					for (let i = 0; i < this.mzl.length; i++) {
						if (this.mzl[i].id === this.lines[j].f_16) {
							this.mzl[i].value += +this.lines[j].f_22
						}
					}
				}

				for (let i = 0; i < this.mzl.length; i++) {
					this.mzl[i].value = this.floatConvert(this.mzl[i].value)
				}

				for (let i = 0; i < this.lines.length; i++) {
					s += +this.lines[i].f_22
				}

				this.summ_s_action_type = this.floatConvert(s)

			},
			addLine () {
				let obj = {}
				for (let i = 16; i <= 27; i++) {
					obj[`f_${i}`] = ''
				}
				obj.correct_f_17 = 'field-error'
				obj.correct_f_20 = 'field-error'
				obj.correct_f_21 = 'field-error'
				obj.correct_f_22 = 'field-error'
				obj.correct_f_24 = 'field-error'

				this.lines.push(obj)
				this.lines_correct = ''
			},
			copyLine () {
				//console.warn(this.lines)
				document.querySelectorAll('tbody .checkbox').forEach(checkbox => {
					if (checkbox.checked) {
						checkbox.checked = false
						let index = checkbox.getAttribute('data-index')
						let line_to_copy = Object.assign({}, this.lines[index])
						line_to_copy.f_c = null
						
						for(let l in line_to_copy)
							if(line_to_copy[l] == null)
								delete line_to_copy[l]

						this.lines.push(line_to_copy)
					}
				})
				document.getElementById('chkBoxSelAll').checked = false
			},
			deleteLine () {
				document.querySelectorAll('tbody .checkbox').forEach(checkbox => {
					if (checkbox.checked) {
						let index = checkbox.getAttribute('data-index')
						
						checkbox.parentNode.parentNode.remove()

						for (let i = 16; i <= 27; i++) {
							this.lines[index][`f_${i}`] = null
						}

						if (this.lines[index].f_c) {
							this.prepareToDelete.push(this.lines[index].f_c)
						}

						this.lines[index].f_d = true

					}
				})
				document.getElementById('chkBoxSelAll').checked = false

				let c = true
				for (let i = 0; i < this.lines.length; i++) {
					if (typeof this.lines[i].f_d === 'undefined') {
						c = false
						break
					}
				}
				
				this.lines_correct = c ? 'field-error' : ''
			},
			selectAll () {
				document.querySelectorAll('tbody .checkbox').forEach(checkbox => {
					checkbox.checked = document.getElementById('chkBoxSelAll').checked
				})
			},
			clear () {
				this.lines.forEach(line => {
					line.f_d = true
				})

				document.querySelectorAll('tbody .checkbox').forEach(checkbox => {
					checkbox.parentNode.parentNode.remove()
				})
			},
			checkFields () {
				const main_fields = [1,2,3,5,9,11,12,13]
				const location_fields = [17,20,21,24]
				let result = true
				
				for (let i of main_fields) {
					result = result && !!this[`f_${i}`]	//one false = result false, all true = result true
				}

				result = result && !!this.lines.length	//lines.length == 0 => result false

				let deleted_lines_count = 0
				for (let j = 0; j < this.lines.length; j++) {
					if (this.lines[j].f_d)
						deleted_lines_count++
				}

				for (let i of location_fields) {
					for (let j = 0; j < this.lines.length; j++) {
						if (!this.lines[j].f_d)
							result = result && !!this.lines[j][`f_${i}`]
					}
				}

				if (deleted_lines_count === this.lines.length)	//all lines is deleted => result false
					result = false

				return result
			},
			submit () {
				this.submit_disabled = true

				for (let i = 0; i < this.lines.length; i++) {
					if(this.lines[i].f_16 == this.mzlRAD.id && !Number.isInteger(Number(this.lines[i].f_22)))
					{
						EventBus.$emit(`show_tooltip_mzl_add`, {id: i})
						this.submit_disabled = false
						return false
					}
				}

				let obj = {}
				obj.tab = [{}]
				obj.tab[0].tab_id = 1
				obj.tab[0].f_v = {}

				for (let i = 1; i <= 15; i++) {
					if ((i === 1 || i === 3 || i === 5 || i === 7) && (this[`f_${i}`] !== '')) {
						obj.tab[0].f_v[`f_${i}`] = this[`f_${i}`]
					}
					else if ((i === 6 || i === 9 || i === 11 || i === 12) && (this[`f_${i}`] != 0)) {
						obj.tab[0].f_v[`f_${i}`] = this[`f_${i}`]
					}
					
					if (i !== 1 && i !== 3 && i !== 5 && i !== 7 && i !== 6 && i !== 9 && i !== 11 && i !== 12 && this[`f_${i}`] !== '') {
						if (i === 13 || i === 14) {
							obj.tab[0].f_v[`f_${i}`] = commaToPeriod(this[`f_${i}`])
						}
						else {
							obj.tab[0].f_v[`f_${i}`] = this[`f_${i}`]
						}
					}
				}


				obj.tab[0].f_v.f_88 = this.f_88
				obj.tab[0].f_v.f_89 = this.f_89
				obj.tab[0].f_v.f_90 = this.f_90

				obj.tab[0].f_v.f_126 = this.f_126
				obj.tab[0].f_v.f_127 = this.f_127 || ""
				obj.tab[0].f_v.f_128 = this.f_128 || ""
				obj.tab[0].f_v.f_129 = this.f_129
				obj.tab[0].f_v.f_130 = this.f_130

				if(this.f_115)
					obj.tab[0].f_v.f_115 = commaToPeriod(this.f_115)

				obj.tab[0].tab = []

				for (let i = 0; i < this.lines.length; i++) {
					if (!this.lines[i].f_d) {
						obj.tab[0].tab.push({})

						obj.tab[0].tab[obj.tab[0].tab.length - 1].tab_id = 2
						obj.tab[0].tab[obj.tab[0].tab.length - 1].f_v = {}

						for (let j = 16; j <= 26; j++) {
							if (this.lines[i][`f_${j}`])
								if (j === 21 || j === 22 || j === 23) {
									obj.tab[0].tab[obj.tab[0].tab.length - 1].f_v[`f_${j}`] = commaToPeriod(this.lines[i][`f_${j}`])
								}
								else {
										obj.tab[0].tab[obj.tab[0].tab.length - 1].f_v[`f_${j}`] = this.lines[i][`f_${j}`]
								}
						}
						if(Number(this.lines[i]['f_27']))
							obj.tab[0].tab[obj.tab[0].tab.length - 1].f_v['f_27'] = this.lines[i]['f_27']

						obj.tab[0].tab[obj.tab[0].tab.length - 1].f_v['f_104'] = this.lines[i]['f_104']
						obj.tab[0].tab[obj.tab[0].tab.length - 1].f_v['f_105'] = this.lines[i]['f_105']
						if(this.lines[i]['f_106'])
							obj.tab[0].tab[obj.tab[0].tab.length - 1].f_v['f_106'] = this.lines[i]['f_106']

						if(this.lines[i]['f_111'])
							obj.tab[0].tab[obj.tab[0].tab.length - 1].f_v['f_111'] = this.lines[i]['f_111']
						if(this.lines[i]['f_112'])
							obj.tab[0].tab[obj.tab[0].tab.length - 1].f_v['f_112'] = this.lines[i]['f_112']
						if(this.lines[i]['f_113'])
							obj.tab[0].tab[obj.tab[0].tab.length - 1].f_v['f_113'] = this.lines[i]['f_113']
						if(this.lines[i]['f_114'])
							obj.tab[0].tab[obj.tab[0].tab.length - 1].f_v['f_114'] = this.lines[i]['f_114']
						if(this.lines[i]['f_116'])
							obj.tab[0].tab[obj.tab[0].tab.length - 1].f_v['f_116'] = this.lines[i]['f_116']
						if(this.lines[i]['f_131'])
							obj.tab[0].tab[obj.tab[0].tab.length - 1].f_v['f_131'] = this.lines[i]['f_131']
					}
				}

				//console.log(obj)

				// console.log(JSON.stringify(obj))
				const submit_act_info = () => {
					let form = new FormData()
					form.append('json', JSON.stringify(obj))
					
					let zero_check_result = null
					const zero_check = setTimeout(() => {
						if(zero_check_result === null)
						{
							zero_check_result = false
							const save = confirm('Во время сохранения акта произошла ошибка. Сохранить файл с отладочной информацией для отправки разработчикам?')

							if(save)
								this.download(JSON.stringify(obj) + '_timeout', 'edit_' + Date() + '.json', 'text/json')

							this.submit_disabled = false
						}
					}, TIMEOUT)

					fetch(DB + FIND_ACT + `?create_date=${this.f_1}&adoption_date=${this.f_5}&placement_date=${this.f_3}&act_num=${this.f_2}&forestry_id=${this.f_9}`)
					.then(res => res.json())
					.then(res => {
						if(zero_check_result === null)
						{
							clearTimeout(zero_check)
							zero_check_result = true
							if(res.czl_get_act_id > -1)
							{
								this.submit_disabled = false
								alert('Данный акт уже присутствует в системе. Обратитесь к администратору')
							}
							else
							{
								let first_check_result = null
								let second_check_result = null

								const first_check = setTimeout(() => {
									if(first_check_result === null)
									{
										first_check_result = false
										const second_check = setTimeout(() => {
											if(second_check_result === null)
											{
												second_check_result = false
												alert('Во время сохранения акта произошла ошибка. Повторите попытку позже.')
												this.submit_disabled = false
											}
										}, TIMEOUT)

										fetch(DB + FIND_ACT + `?create_date=${this.f_1}&adoption_date=${this.f_5}&placement_date=${this.f_3}&act_num=${this.f_2}&forestry_id=${this.f_9}`)
										.then(res => res.json())
										.then(res => {
											if(second_check_result === null)
											{
												second_check_result = true
												clearTimeout(second_check)
												if(res.czl_get_act_id && res.czl_get_act_id > -1)
												{
													alert('Акт сохранен')
													this.submit_disabled = false
													if(this.$parent.lastJournalURL)
														router.replace(this.$parent.lastJournalURL)
													else
														router.replace('/main')
												}
												else
												{
													alert('Во время сохранения акта произошла ошибка. Повторите попытку позже.')
													this.submit_disabled = false
												}
											}
											
										})
										.catch(e => {
											alert('Во время сохранения акта произошла ошибка. Повторите попытку позже.')
											this.submit_disabled = false
										})
									}
								}, TIMEOUT);

								//console.warn(this.f_1, this.f_2, this.f_9)

								fetch(DB + INSERT_JSON, {
									method: 'post',
									body: form
								})
								.then(result => result.json())
								.then(result => {
									if(first_check_result === null)
									{
										first_check_result = true
										clearTimeout(first_check)
										if(result[0].code === '0') {
											alert('Акт сохранен')
											router.replace('/main')
											this.submit_disabled = false
										}
										else {
											alert('Во время сохранения акта произошла ошибка. На Ваш компьютер будет сохранён файл с отладочной информацией. Перешлите данный файл вместе со скриншотом экрана разработчикам для выявления и устранения ошибки.')
											this.download(JSON.stringify(obj) + '_' + result[0].name, 'edit_' + Date() + '.json', 'text/json')
											this.submit_disabled = false
										}
									}
								})
								.catch(err => {
									alert('Во время сохранения акта произошла ошибка. Повторите попытку позже.')
									this.submit_disabled = false
									console.log(err)
								})
							}
						}
					})
				}
				if (this.checkFields()) {
					if(document.querySelector('.field-error') !== null)
					{
						const b = confirm('Часть полей может содержать некорректные данные. Вы уверены, что хотите продолжить?')
						if(b)
						{
							submit_act_info()
						} else 
						{
							this.submit_disabled = false
						}
					} else 
					{
						submit_act_info()
					}
				}
				else {
					alert('Поля, отмеченные звёздочкой, обязательны к заполнению.')
					this.submit_disabled = false
				}
			},
			close () {
				if(this.$parent.lastJournalURL)
					router.replace(this.$parent.lastJournalURL)
				else
					router.replace('/main')
			},
			download(content, fileName, contentType) {
			    var a = document.createElement("a");
			    var file = new Blob([content], {type: contentType});
			    a.href = URL.createObjectURL(file);
			    a.download = fileName;
			    var event = document.createEvent("MouseEvents");
		        event.initMouseEvent(
		                "click", true, false, window, 0, 0, 0, 0, 0
		                , false, false, false, false, 0, null
		        );
			    a.dispatchEvent(event);
			},
			tdChange(e) {
				const f = e.target.getAttribute('data-field')
				const l = e.target.getAttribute('line_count')
				if (f === 'f_21') {
					e.target.value = e.target.value.replace(/[,-]/g, ".")
				}
				
				this.lines[l][`correct_${f}`] = e.target.value === '' ? 'field-error' : 'place-success'
			},
			adoptionChange (e) {
				if (e) {
					if (this.f_3) {
						const adoption = moment(e, 'DD.MM.YYYY')
						const place = moment(this.f_3, 'DD.MM.YYYY')
						const diff = place.diff(adoption, 'days')

						let dp_adoption = document.getElementById('datepicker_f_5').firstChild
						let dp_placement = document.getElementById('datepicker_f_3').firstChild

						if (diff < 0 || diff > 3) {
							if (!dp_adoption.classList.contains('error')) {
								dp_adoption.classList.add('error')
								dp_placement.classList.add('error')
								this.fields_correct.f_3 = 'error'
								this.fields_correct.f_5 = 'error'
							}
						}
						else {
							dp_adoption.classList.remove('error')
							dp_placement.classList.remove('error')
							this.fields_correct.f_3 = ''
							this.fields_correct.f_5 = ''
						}
					}
					else {
						this.fields_correct.f_5 = 'field-success'
					}
				}
				else {
					document.getElementById('datepicker_f_3').firstChild.classList.remove('error')
					document.getElementById('datepicker_f_5').firstChild.classList.remove('error')
					this.fields_correct.f_5 = 'field-error'
					this.fields_correct.f_3 = this.fields_correct.f_3 !== 'field-error' ? 'field-success' : 'field-error'
				}
			},
			placeChange (e) {
				if (e) {
					let d = moment(e, 'DD.MM.YYYY')
					d.add(20, 'd')
					let now = moment()

					this.controlTwenty = d.format('DD.MM.YYYY')
					this.daysLeft = d.diff(now, 'days')

					if (this.f_5) {
						const adoption = moment(this.f_5, 'DD.MM.YYYY')
						const place = moment(e, 'DD.MM.YYYY')
						const diff = place.diff(adoption, 'days')

						let dp_adoption = document.getElementById('datepicker_f_5').firstChild
						let dp_placement = document.getElementById('datepicker_f_3').firstChild

						if (diff < 0 || diff > 3) {
							if (!dp_adoption.classList.contains('error')) {
								dp_adoption.classList.add('error')
								dp_placement.classList.add('error')
								this.fields_correct.f_3 = 'error'
								this.fields_correct.f_5 = 'error'
							}
						}
						else {
							dp_adoption.classList.remove('error')
							dp_placement.classList.remove('error')
							this.fields_correct.f_3 = ''
							this.fields_correct.f_5 = ''
						}
					}
					else {
						this.fields_correct.f_3 = ''
					}
				}
				else {
					this.controlTwenty = ''
					this.daysLeft = ''

					document.getElementById('datepicker_f_3').firstChild.classList.remove('error')
					document.getElementById('datepicker_f_5').firstChild.classList.remove('error')
					this.fields_correct.f_3 = 'field-error'
					this.fields_correct.f_5 = this.fields_correct.f_5 !== 'field-error' ? 'field-success' : 'field-error'

				}
			},
			checkS_LPO () {
				const locations_S_sum = this.lines.length ? this.lines.reduce((a, cur) => {return a + Number(cur.f_21)}, 0) : 0
				const locations_S_MZL_sum = this.lines.length ? this.lines.reduce((a, cur) => {
					//console.warn(cur)
					return a + (cur.f_16 == 563 ? 0 : Number(cur.f_22))//Для всех, кроме РАД
				}, 0) : 0
				//console.warn(Number(this.f_13), locations_S_sum, locations_S_MZL_sum)
				this.fields_correct.f_13 = (this.f_13 === '' || this.f_13 === null || Number(this.f_13) > locations_S_sum || Number(this.f_13) < locations_S_MZL_sum) ? 'field-error' : ''
			},
			change_f_129() {
				this.f_130 = null
				this.f_128 = ""
			},
			setSKSAllLocations(val) {
				const newLines = [...this.lines]
				for (const line of newLines) {
					line[val.field] = val.value
				}
				this.lines = newLines
			}
		},
		created () {
			EventBus.$on(`add_region`, (id) => {
				this.f_12 = id
				this.f_9 = 0
				this.clear()
				this.fields_correct.f_12 = (id === '0') ? 'field-error' : ''
				this.fields_correct.f_9 = 'field-error'
			})
			EventBus.$on('add_forestry', (id, add_line = true) => {
				this.f_9 = id
				this.clear()
				this.fields_correct.f_9 = (id === '0') ? 'field-error' : ''

				if(add_line) {
					this.addLine()
				}
			})
			EventBus.$on('add_localforestry', data => {
				this.lines[data.index].f_20 = +data.value

				this.lines[data.index].correct_f_20 = +data.value === 0 ? 'field-error' : 'place-success'
			})
			EventBus.$on('add_subforestry', data => {
				this.lines[data.index].f_27 = data.value
			})
			EventBus.$on('conclusion_user', id => {
				this.f_6 = id
			})
			EventBus.$on('species', data => {
				this.lines[data.index].f_26 = data.value
			})
			EventBus.$on('organization', id => {
				this.f_11 = id
				this.fields_correct.f_11 = (id === '0') ? 'field-error' : ''
			})
			EventBus.$on('action_type', data => {
				this.lines[data.index].f_16 = +data.value

				for (let i = 0; i < this.mzl.length; i++) {
					this.mzl[i].value = 0
				}

				for (let j = 0; j < this.lines.length; j++) {
					for (let i = 0; i < this.mzl.length; i++) {
						if (this.mzl[i].id === this.lines[j].f_16) {
							this.mzl[i].value += +this.lines[j].f_22
						}
					}
				}

				for (let i = 0; i < this.mzl.length; i++) {
					this.mzl[i].value = this.floatConvert(this.mzl[i].value)
				}
			})
			EventBus.$on('deletion_reason', id => {
				this.f_8 = id
			})
			EventBus.$on('damages', data => {
				this.lines[data.index].f_19 = data.value
			})

			EventBus.$on('lpo_reason', id => {
				this.f_88 = id
			})
			EventBus.$on('lpo_method', id => {
				this.f_89 = id
			})
			EventBus.$on('lpo_mode', id => {
				this.f_90 = id
			})
			//---------------------
			EventBus.$on('add_forest_purpose', data => {
				if(this.lines[data.index]) {
					this.lines[data.index].f_104 = data.value
				} else {
					this.lines[data.index] = {}
				}
			})
			EventBus.$on('add_protective_cat', data => {
				if(this.lines[data.index]) {
					this.lines[data.index].f_105 = data.value
				} else {
					this.lines[data.index] = {}
				}
				
			})
			EventBus.$on('add_protective_cat_ext', data => {
				this.lines[data.index].f_106 = data.value
			})

			fetch(DB + CAN_EDIT + '?act_id=0&unit_id=1', { //Can create act?
				credentials: 'include'
			})
			.then(res => res.json())
			.then(res => {
				if(res[0].czl_check_can_edit_unit == null)
					router.replace('/main')
			})
			.catch(err => console.log(err))
		},
		mounted () {
			fetch(DB + ACTION_TYPE, {
				credentials: 'include'
			})
			.then(res => res.json())
			.then(res => {
				if (res) {
					let tmp = []
					for (let i = 1; i < res.length; i++) {
						tmp.push({id: +res[i].id, name: res[i].name, value: 0})
					}
					this.mzl = tmp
				}
				else
					this.mzl = []
			})
			.catch(err => console.log(err))

			fetch(DB + LPO_FILIALS, {
				credentials: 'include'
			})
			.then(data => data.json())
			.then(data => {
				if (data) {
					this.lpo_filials = data
				}
			})
			.catch(err => console.log(err))

			fetch(DB + ORGANIZATION_LPO, {
				credentials: 'include'
			})
			.then(data => data.json())
			.then(data => {
				if (data) {
					this.organization_types = data
				}
			})
			.catch(err => console.log(err))

			
			//console.warn('params', this.$route.params)

			if(this.$route.params && Object.keys(this.$route.params) && Object.keys(this.$route.params).length) {
				const p = this.$route.params
				this.f_2 = p.act_num

				this.f_1 = p.date_of_realization
				this.f_5 = p.date_of_approval
				this.f_3 = p.date_of_publication

				this.f_13 = p.s_lpo.replace('.', ',')

				this.f_89 = +p.lpo_method_id
				//this.f_90 = +p.lpo_mode_id

				if(p.lines && p.lines.length) {
					for(let line of p.lines) {
						let obj = {}
						for (let i = 16; i <= 27; i++) {
							obj[`f_${i}`] = ''
						}
						obj.correct_f_17 = line.area ? '' : 'field-error'
						obj.correct_f_20 = line.localforestry_id ? '' : 'field-error'
						obj.correct_f_21 = line.section_s ? '' : 'field-error'
						obj.correct_f_22 = line.action_s ? '' : 'field-error'
						obj.correct_f_24 = line.section ? '' : 'field-error'

						obj.f_20 = line.localforestry_id
						obj.f_17 = line.area 
						obj.f_24 = line.section
						obj.f_21 = line.section_s
						obj.f_25 = line.lp_section
						obj.f_23 = line.lp_section_s

						obj.f_111 = line.composition
						obj.f_112 = line.age
						obj.f_113 = line.сompleteness
						obj.f_114 = line.reserve

						obj.f_131 = line.sks

						obj.f_22 = line.action_s
						obj.f_116 = line.volume
						obj.f_18 = line.comment

						if(line.protection_cat_ext_id) {
							obj.f_105 = +line.protection_cat_ext_id
						}
						if(line.species_id) {
							obj.f_26 = +line.species_id
						}
						if(line.damages_id) {
							obj.f_19 = +line.damages_id
						}
						if(line.action_id) {
							obj.f_16 = +line.action_id
						}
						if(line.purpose_id) {
							obj.f_104 = +line.purpose_id
						}

						this.lines.push(obj)
					}
					this.lines_correct = ''
					
					this.addSLP(false)
					this.addSAT(false)
				}

				EventBus.$emit('add_region', +p.region_id)
				EventBus.$emit('add_forestry', +p.forestry_id, false)
			}
		},
		beforeDestroy () {
			EventBus.$off(`add_region`)
			EventBus.$off('add_forestry')
			EventBus.$off('add_localforestry')
			EventBus.$off('add_subforestry')
			EventBus.$off('conclusion_user')
			EventBus.$off('species')
			EventBus.$off('organization')
			EventBus.$off('action_type')
			EventBus.$off('deletion_reason')
			EventBus.$off('damages')
			EventBus.$off('lpo_reason')
			EventBus.$off('lpo_method')
			EventBus.$off('lpo_mode')
		},
		watch: {
			lines: {
		      handler: function (val, oldVal) {
		        this.checkS_LPO()
		        this.value_summ = 0
		        for(let line in this.lines)
		        {
		        	if(this.lines[line].f_21 != undefined)
		        		this.lines[line].f_21 = this.lines[line].f_21.replace(/[,-]/g, ".").replace(/[^\.\d]/g, "")

		        	if(this.lines[line].f_112 != undefined)
		        		this.lines[line].f_112 = this.lines[line].f_112.replace(/[^\d]/g, "")

		        	if(this.lines[line].f_113 != undefined)
		        		this.lines[line].f_113 = this.lines[line].f_113.replace(/[,-]/g, ".").replace(/[^\.\d]/g, "")

		        	if(this.lines[line].f_114 != undefined)
		        		this.lines[line].f_114 = this.lines[line].f_114.replace(/[,-]/g, ".").replace(/[^\.\d]/g, "")

					if(this.lines[line].f_131 != undefined)
		        		this.lines[line].f_131 = this.lines[line].f_131.replace(/[,-]/g, ".").replace(/[^\.\d]/g, "")

		        	if(this.lines[line].f_116 != undefined)
		        	{
		        		this.lines[line].f_116 = this.lines[line].f_116.replace(/[,]/g, ".").replace(/[.]{2,}/g, ".").replace(/[^\.\d]/g, "")
		        		this.value_summ += Number(this.lines[line].f_116)
		        	}

					this.lines[line].correct_f_22 = !this.lines[line].f_22 || !this.lines[line].f_22.length ? 'field-error' : 'place-success'
		        	this.lines[line].correct_f_23 = Number(this.lines[line].f_23) > Number(this.lines[line].f_21) ? 'field-error' : 'place-success'
		        }
		        
		        this.value_summ = this.floatConvert(this.value_summ)
		      },
		      deep: true
		    },
			f_2 (e) {
				this.fields_correct.f_2 = (e === '') ? 'field-error' : ''
			},
			f_13 (e) {
				this.fields_correct.f_13 = (e === '') ? 'field-error' : ''
				this.checkS_LPO()
			},
			f_115 (e) {
				if(!e) {
					this.fields_correct.f_115 = ''
					return
				}

				const r = new RegExp("^-?\\d*(\\.\\d+)?$", "g") //numeric
				this.fields_correct.f_115 = r.test(e) ? '' : 'field-error'
			},
			f_1 (e) {
				const arr_f_5 = this.f_5.split('.')
				const date_f_5 = new Date(+arr_f_5[2], (+arr_f_5[1] - 1), +arr_f_5[0])
				const arr_f_1 = this.f_1.split('.')
				const date_f_1 = new Date(+arr_f_1[2], (+arr_f_1[1] - 1), +arr_f_1[0])
				if(date_f_5 < date_f_1)
				{
					this.fields_correct.f_1 = 'field-error'
					this.fields_correct.f_5 = 'field-error'
				} else {
					this.fields_correct.f_1 = (e === '' || e === null) ? 'field-error' : 'field-success'
					this.fields_correct.f_5 = (this.f_5 === '' || this.f_5 === null) ? 'field-error' : 'field-success'
				}
			},
			f_5 (e) {
				const arr_f_5 = this.f_5.split('.')
				const date_f_5 = new Date(+arr_f_5[2], (+arr_f_5[1] - 1), +arr_f_5[0])
				const arr_f_1 = this.f_1.split('.')
				const date_f_1 = new Date(+arr_f_1[2], (+arr_f_1[1] - 1), +arr_f_1[0])
				if(date_f_5 < date_f_1)
				{
					this.fields_correct.f_1 = 'field-error'
					this.fields_correct.f_5 = 'field-error'
				} else 
				{
					this.fields_correct.f_1 = (this.f_5 === '' || this.f_5 === null) ? 'field-error' : 'field-success'
					this.fields_correct.f_5 = (e === '' || e === null) ? 'field-error' : 'field-success'
				}
			},
			mzl (e) {
				let result = this.mzl.slice(0)
				for(let e in result)
				{
					if(result[e].name == 'РАД')
					{
						this.mzlRAD = result[e]
						result.splice(e,1)
					}
				}
				this.mzlNoRAD = result
				this.mzlRAD = this.mzlRAD ? this.mzlRAD : {name: 'РАД', value: '0'}
			},
			f_126 (e) {
				this.fields_correct.f_126 = e === null ? 'field-error' : 'field-success'
			},
			f_127 (e) {
				this.fields_correct.f_127 = !e ? 'field-error' : 'field-success'
			},
			f_128 (e) {
				this.fields_correct.f_128 = !e ? 'field-error' : 'field-success'
			},
			f_130 (e) {
				this.fields_correct.f_130 = !e ? 'field-error' : 'field-success'
			}
		}
	}

	function commaToPeriod(str) {
		return str.replace(/,/g, ".")
	}
</script>

<style>
.rent-title {
	width: 100px;
	text-align: center;
}

.no-bottom-border {
	border-bottom: none;
}

.no-right-border {
	border-right: none !important;
}

/* 	div.datepicker.field-error > input {
	background-color: lightcoral;
} */

div.datepicker {
	width: 100%;
}

/* div.datepicker.table-control > input.form-control {
	border: none !important;
	height: 24px;
	margin: 0px;
	display: inline-table !important;
} */

div.datepicker.table-control > input.error {
	background-color: lightcoral;
}

td.error {
	background-color: lightcoral;
}
/* 	textarea.form-control{
	resize: none;
	height: 60px;
} */

.my-control {
	padding-left: 5px !important;
	padding-top: 0px !important;
	padding-bottom: 0px !important;
	margin-bottom: 5px;
	height: 24px !important;
	display: inline-table !important;
	font-size: 12px !important;
}

.table-control {
	height: 24px;
	width: 100%;
	margin: 0px;
	border: none !important;
}

select.my-control:not([size]):not([multiple]) {
	height: 24px !important;
}

.clearBtn {
	margin-right: 10px;
}

.left_input_wrapper {
	height: 30px;
    line-height: 24px;
}
</style>


// WEBPACK FOOTER //
// addForm.vue?a0f79966